import enLocale from 'date-fns/locale/en-US';
import enCALocale from 'date-fns/locale/en-CA';
import enGBLocale from 'date-fns/locale/en-GB';
import enAULocale from 'date-fns/locale/en-AU';
import cnLocale from 'date-fns/locale/zh-CN';
import jaLocale from 'date-fns/locale/ja';
import daLocale from 'date-fns/locale/da';
import noLocale from 'date-fns/locale/nn';
import svLocale from 'date-fns/locale/sv';
import koLocale from 'date-fns/locale/ko';
import arLocale from 'date-fns/locale/ar-SA';
import ruLocale from 'date-fns/locale/ru';
import ptLocale from 'date-fns/locale/pt';
import itLocale from 'date-fns/locale/it';
import nlLocale from 'date-fns/locale/nl';
import esLocale from 'date-fns/locale/es';
import frLocale from 'date-fns/locale/fr';
import deLocale from 'date-fns/locale/de';

export const localeMap = {
  en: enLocale,
  'en-CA': enCALocale,
  'en-GB': enGBLocale,
  'en-AU': enAULocale,
  cn: cnLocale,
  ja: jaLocale,
  da: daLocale,
  no: noLocale,
  sv: svLocale,
  ko: koLocale,
  ar: arLocale,
  ru: ruLocale,
  pt: ptLocale,
  it: itLocale,
  nl: nlLocale,
  es: esLocale,
  fr: frLocale,
  de: deLocale,
};

export const localeDateFormatMap = {
  en: 'MM/DD/YYYY',
  'en-CA': 'DD/MM/YYYY',
  'en-GB': 'DD/MM/YYYY',
  'en-AU': 'DD/MM/YYYY',
  cn: 'YYYY/MM/DD',
  ja: 'YYYY年MM月DD',
  da: 'DD-MM-YYYY',
  no: 'DD.MM.YYYY',
  sv: 'YYYY-MM-DD',
  ko: 'YYYY.MM.DD',
  ar: 'DD/MM/YYYY',
  ru: 'DD.MM.YYYY',
  pt: 'DD/MM/YYYY',
  it: 'DD/MM/YYYY',
  nl: 'DD-MM-YYYY',
  es: 'DD/MM/YYYY',
  fr: 'DD/MM/YYYY',
  de: 'DD.MM.YYYY',
};
